import { createSlice } from '@reduxjs/toolkit';
import { ASSESSMENT_CYCLES } from '../../actions/AssessmentCycles/actionTypes';

const initialState = {
  assessmentCycles: {
    isLoading: false,
    data: {
      assessmentCycles: [],
      cycleTypes: [],
      innovation: [],
      contribution: [],
      skills: [],
      assessment: [],
      skillArea: [],
      assessmentCycle: null
    },
    errors: '',
    message: ''
  }
};
console.log('Reducer: Initial State', JSON.parse(JSON.stringify(initialState)));

export const assessmentCyclesSlice = createSlice({
  name: ASSESSMENT_CYCLES,
  initialState,
  reducers: {
    getAssessmentCyclesAction: (state) => {
      state.assessmentCycles.isLoading = true;
      state.assessmentCycles.errors = '';
    },
    getAssessmentCyclesSuccessAction: (state, action) => {
      //console.log('Reducer: Current State Before Update', JSON.parse(JSON.stringify(state)));
      //console.log('Reducer: Action Payload', action.payload);
      if (action.payload) {
        state.assessmentCycles.data.assessmentCycles = action.payload?.assessmentCycleList;
        state.assessmentCycles.data.cycleTypes = action.payload?.assessmentCycleTypeList;
        state.assessmentCycles.data.innovation = action.payload?.innovationTypeQuestions;
        state.assessmentCycles.data.contribution = action.payload?.contributionTypeQuestions;
        state.assessmentCycles.data.skills = action.payload?.skillArea;
        state.assessmentCycles.data.assessment = action.payload?.assessmentList;
        state.assessmentCycles.data.skillArea = action.payload.skillArea;
      }
      state.assessmentCycles.isLoading = false;
      //console.log("Reducer: State After Update", JSON.parse(JSON.stringify(state)));
    },
    getAssessmentCyclesListSuccessAction: (state, action) => {
      if(action.payload) {
        state.assessmentCycles.data.assessmentCycles = action.payload?.assessmentCycleList;
        state.assessmentCycles.data.cycleTypes = action.payload?.assessmentCycleTypeList;
        state.assessmentCycles.data.innovation = action.payload?.innovationTypeQuestions;
        state.assessmentCycles.data.contribution = action.payload?.contributionTypeQuestions;
        state.assessmentCycles.data.skills = action.payload?.skillArea;
        state.assessmentCycles.data.assessment = action.payload?.assessmentList;
      }
      state.assessmentCycles.isLoading = false;
    },
    getAssessmentCyclesFailureAction: (state, action) => {
      // state.user.isLoading = false;
      state.assessmentCycles.isLoading = false;
      state.assessmentCycles.errors = action.payload;
    },
    getAssessmentCyclesListFailureAction: (state, action) => {
      // state.user.isLoading = false;
      state.assessmentCycles.isLoading = false;
      state.assessmentCycles.errors = action.payload;
    },
    setAssessmentCyclesAction: (state) => {
      state.assessmentCycles.isLoading = true;
      state.assessmentCycles.errors = '';
    },
    setAssessmentCyclesSuccessAction: (state, action) => {
      state.assessmentCycles.isLoading = false;
      state.assessmentCycles.errors = '';
      // state.assessmentCycles.message = action.payload?.message ? action.payload?.message : 'Assessment Cycle Saved';
      if (action.payload?.data >= 1) {
        state.assessmentCycles.message = 'Assessment Cycle Saved';
      }
      //data =0 means not saved. Checking cycle name existence failed
      else if (action.payload?.data === 0) {
        state.assessmentCycles.errors = 'Can not save. Cycle name already exists!';
      }
      //data =-1 means not saved. We can have only one active cycle at a time
      else if (action.payload?.data === -1) {
        state.assessmentCycles.errors = 'Can not save.Another active Cycle already exists in this type!';
      }
    },
    setAssessmentCyclesFailureAction: (state, action) => {
      state.assessmentCycles.isLoading = false;
      state.assessmentCycles.errors = action.payload;
    },
    getAssessmentCycleAction: (state) => {
      state.assessmentCycles.isLoading = true;
      state.assessmentCycles.errors = '';
      state.assessmentCycles.data.assessmentCycle = null;
    },
    getAssessmentCycleSuccessAction: (state, action) => {
      if (action.payload) {
        state.assessmentCycles.isLoading = false;
        state.assessmentCycles.data.assessmentCycle = action.payload;
      }
    },
    getAssessmentCycleFailureAction: (state, action) => {
      state.assessmentCycles.isLoading = false;
      state.assessmentCycles.errors = action.payload;
    },

    resetAssessmentCycleAction: (state) => {
      state.assessmentCycles.message = '';
      state.assessmentCycles.errors = '';
      state.assessmentCycles.data.assessmentCycle = null;
    }
  }
});

export const {
  getAssessmentCyclesAction,
  getAssessmentCyclesFailureAction,
  getAssessmentCyclesListFailureAction,
  getAssessmentCyclesSuccessAction,
  getAssessmentCyclesListSuccessAction,
  setAssessmentCyclesAction,
  setAssessmentCyclesFailureAction,
  setAssessmentCyclesSuccessAction,
  getAssessmentCycleAction,
  getAssessmentCycleFailureAction,
  getAssessmentCycleSuccessAction,
  resetAssessmentCycleAction
} = assessmentCyclesSlice.actions;

export default assessmentCyclesSlice.reducer;
